import { DOCUMENT } from '@angular/common';
import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SwUpdate } from '@angular/service-worker';
import { filter, fromEvent, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PwaUpdateService {
  private readonly swUpdate = inject(SwUpdate);
  private readonly document = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);

  reloadWhenNewVersionIsReady(): void {
    if (!this.swUpdate.isEnabled) return;

    this.swUpdate.versionUpdates
      .pipe(
        filter((event) => event.type === 'VERSION_READY'),
        take(1),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.reloadWhenHidden());

    this.swUpdate.unrecoverable.pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(() => this.reload());
  }

  private reloadWhenHidden(): void {
    if (this.document.visibilityState === 'hidden') {
      this.reload();
      return;
    }

    fromEvent(this.document, 'visibilitychange')
      .pipe(
        filter(() => this.document.visibilityState === 'hidden'),
        take(1),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.reload());
  }

  private reload(): void {
    this.document.location.reload();
  }
}
